import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import Input from '../../common/Input';

const PersonalData = ({
  formData,
  invalidFields,
  handleChange,
  handleBlur,

  nations,
  getCities
}) => {
  const { t } = useTranslation();

  const handleBirthNationChange = (field, value) => {
    handleChange(field, value);
    handleChange('birthCity', '');
    handleChange('birthProvince', '');
  };

  const handleBirthCityChange = (field, value, callback) => {
    handleChange(field, value);
    handleChange('birthProvince', '');
    if (formData.birthNation !== 'ITALIA') {
      return;
    }
    getCities(value).then(res => callback(res));
  };

  const handleBirthCitySelect = (option) => {
    handleChange('birthCity', option.comune);
    handleChange('birthProvince', option.provincia);
  };

  return <div className='customer__form__data data--personal'>
    {['sole-proprietorship', 'company'].includes(formData.type) && <Input
      type='text'
      name='companyName'
      label={t('customer.form.companyName.label')}
      value={formData.companyName}
      invalid={invalidFields['companyName']}
      onChange={handleChange}
      onBlur={handleBlur}
    />}

    {['driver', 'individual', 'sole-proprietorship'].includes(formData.type) && (<>
      <Input
        type='text'
        name='name'
        label={t('customer.form.name.label')}
        value={formData.name}
        invalid={invalidFields['name']}
        disabled={formData.type === 'individual'}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='text'
        name='surname'
        label={t('customer.form.surname.label')}
        value={formData.surname}
        invalid={invalidFields['surname']}
        disabled={formData.type === 'individual'}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='select'
        name='birthNation'
        label={t('customer.form.birthNation.label')}
        helper={t('customer.form.birthNation.helper')}
        value={formData.birthNation}
        invalid={invalidFields['birthNation']}
        options={['', ...nations]}
        onChange={handleBirthNationChange}
        onBlur={handleBlur}
      />
      <Input
        type='select'
        name='gender'
        label={t('customer.form.gender.label')}
        value={formData.gender}
        invalid={invalidFields['gender']}
        options={[
          { value: '', text: '' },
          { value: 'M', text: t('customer.genders.male') },
          { value: 'F', text: t('customer.genders.female') }
        ]}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='date'
        name='birthDate'
        label={t('customer.form.birthDate.label')}
        value={formData.birthDate}
        invalid={invalidFields['birthDate']}
        datePickerMax={dayjs().subtract(18, 'year').toDate()}
        datePickerMin={dayjs().subtract(90, 'year').toDate()}
        onChange={handleChange}
      />
      <Input
        type={formData.birthNation === 'ITALIA' ? 'autocomplete' : 'text'}
        name='birthCity'
        label={t('customer.form.birthCity.label')}
        value={formData.birthCity}
        invalid={invalidFields['birthCity']}
        onChange={handleBirthCityChange}
        onSelect={handleBirthCitySelect}
        onBlur={handleBlur}
      />
      {formData.birthNation === 'ITALIA' && <Input
        type='text'
        name='birthProvince'
        label={t('customer.form.birthProvince.label')}
        value={formData.birthProvince}
        invalid={invalidFields['birthProvince']}
        disabled
      />}
    </>)}
  </div>;
};

export default PersonalData;